module.exports = __webpack_public_path__ + "static/img/icon_redbag@2x.11d4bf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/ZBActivity/icon_redbag@2x.png
// module id = 1/mk
// module chunks = 70